import React, { useContext, useEffect } from 'react'
import { contextData } from '../../App'
import NatyaFusion from '../../components/NatyaFusion/NatyaFusion';

function NatyaFusionPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className='pt-[114px]'>
        <NatyaFusion/>
    </div>
  )
}

export default NatyaFusionPage